export default __webpack_public_path__ + "static/media/dfm.58e85261.png";